<div class="card desktop">
    <div class="card-header card-info card-inverse">
        <div class="row card-title">
            <span><em *ngIf="isDownloadingData" class="fa fa-spinner rotating"></em>&nbsp;&nbsp;{{ title }}</span>
            <span class=" pull-right" *ngIf="showCounter" style="color:white">
                Totale: {{elementsCounter}}
            </span>
        </div>
    </div>
    <div class="card-block">
        <button *ngIf="allowAdd" (click)="addClicked()" class="btn btn-primary btn-rounded" type="button" [disabled]="isAdding">AGGIUNGI&nbsp;&nbsp;<i class="fa fa-plus "></i></button>
        <div class="table-responsive" [class.datePadding]="isAnyDateEditable()">
            <div class="table-clear-filter" *ngIf="showClearFilters" [style]="showClearFiltersSanitizedStyle">
                <em class="fa fa-eraser fa-2x cur-pointer" (click)="clearFiltersClicked()"></em>
            </div>
            <table class="table table-hover tableTextSize" [class.small-padding]="smallPadding">

                <thead>
                    <tr>
                        <th *ngIf="isAnyEditable()" class="actionColumn"></th>
                        <th *ngIf="allowDelete" class="actionColumn"></th>
                        <th *ngFor="let setting of settings; let i = index" [ngClass]="{'actionColumn' : setting.isActionField || setting.isSelectDownloadField || setting.isImageField || setting.isIconField}" [class.iconColumn]="setting.isIconField">
                            <div *ngIf="setting.isSelectDownloadField" (click)="setting.actionField(selected)" class="pointer">
                                <span *ngIf="!isDownloadingFile" class="fa-stack fa-lg">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-download fa-stack-1x fa-inverse"></i>
                                </span>
                                <em *ngIf="isDownloadingFile" class="fa fa-2x fa-spinner rotating"></em>
                            </div>
                            <a *ngIf="setting.isToSort" class="pointer" (click)="changeSort(i)">{{ setting.fieldTitle }}&nbsp;&nbsp;<em *ngIf="setting.sortValue == 0" class="fa fa-sort"></em><em *ngIf="setting.sortValue == 1" class="fa fa-sort-asc"></em><em *ngIf="setting.sortValue == -1" class="fa fa-sort-desc"></em></a>
                            <div *ngIf="!setting.isToSort">{{ setting.fieldTitle }}</div>
                        </th>
                    </tr>
                    <tr>
                        <th *ngIf="isAnyEditable()"></th>
                        <th *ngIf="allowDelete"></th>
                        <th *ngFor="let setting of settings; let i = index" [class.iconColumn]="setting.isIconField">
                            <input *ngIf="setting.isToSearch && !setting.isRangeSearch && !setting.searchOptions" type="text" class="form-control tableTextSize" placeholder="Cerca ..." [(ngModel)]="setting.searchValue" (keyup)="doSearch()">
                            <input [ngClass]="{'halfWidth' : setting.isRangeSearch }" *ngIf="setting.isToSearch && setting.isRangeSearch" type="text" class="form-control tableTextSize inputTextSearch" placeholder="Da ..." [(ngModel)]="setting.searchValue" (keyup)="doSearch()">
                            <input [ngClass]="{'halfWidth' : setting.isRangeSearch }" *ngIf="setting.isToSearch && setting.isRangeSearch" type="text" class="form-control tableTextSize inputTextSearch" placeholder="Fino a ..." [(ngModel)]="setting.searchRange" (keyup)="doSearch()" />
                            <select style="margin-bottom: 10px;" class="form-control tableTextSize" *ngIf="setting.isToSearch && setting.searchOptions" [(ngModel)]="setting.searchValue" (change)="doSearch()">
                                <option value="">Tutti</option>
                                <option *ngFor="let opt of setting.searchOptions" value="{{ opt }}">{{ opt }}</option>
                            </select>

                            <div *ngIf="isSelectDownloadField(setting.isSelectDownloadField, setting.fieldName)" class="fa pointer" [ngClass]="{'fa-square-o': !selectAll, 'fa-check-square-o': selectAll}" style="margin-bottom: 10px;" (click)="doSelectAll()"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let input of inputs">
                        <td *ngIf="allowDelete">
                            <a (click)="deleteClicked(input)" class="cur-pointer" style="margin-right:8px">
                                <i class="fa fa-trash-o fa-2x"></i>
                            </a>
                        </td>
                        <td *ngIf="isAnyEditable()">
                            <a (click)="editClicked(input)" class="cur-pointer">
                                <i *ngIf="!input._edit" class="fa fa-pencil-square-o fa-2x"></i>
                                <i *ngIf="input._edit" class="fa fa-floppy-o fa-2x"></i>
                            </a>
                        </td>
                        <td *ngFor="let setting of settings; let i = index" [class.imagefield]="setting.isImageField" [class.text-center]="setting.isIconField" [class.iconColumn]="setting.isIconField">
                            <a *ngIf="!input._edit && setting.isActionField && !(setting.isToShowLoading && input._isDownloading) && (setting.enableFieldName ? input[setting.enableFieldName] : true)" class="pointer" (click)="setting.actionField(input)">
                                <em *ngIf="!hideActionFields" class="fa {{ setting.actionClass }} fa-2x"></em>
                            </a>

                            <a *ngIf="!input._edit && setting.isToShowLoading && input._isDownloading">
                                <em class="fa fa-spinner fa-2x rotating"></em>
                            </a>

                            <app-grouped-checkbox *ngIf="setting.isSelectDownloadField || setting.isSelectListField"
                                              [element]="input[setting.fieldName]"
                                              [(selectedElements)]="selected"></app-grouped-checkbox>

                            <div *ngIf="!input._edit && !setting.isActionField && !setting.isSelectDownloadField && !setting.isSelectListField && !setting.isImageField && !setting.isIconField">
                                <span *ngIf="input[setting.fieldName]">
                                    <span *ngIf="!setting.isImageField">
                                        {{ (setting.isDate ? (input[setting.fieldName] | date:'dd/MM/yyyy') : (setting.isDateTime ? (input[setting.fieldName] | date:'dd/MM/yyyy HH:mm:ss') : (setting.isPrice? (input[setting.fieldName] | number:'1.2-2') : input[setting.fieldName])))  }}

                                        <span *ngIf="input[setting.suffix]">
                                            {{ input[setting.suffix] }}
                                        </span>
                                        <span *ngIf="!input[setting.suffix]">
                                            {{ (setting.suffix ? setting.suffix : '') }}
                                        </span>
                                    </span>
                                </span>
                            </div>
                            <input *ngIf="input._edit && !setting.isActionField && !setting.isSelectDownloadField && !setting.isSelectListField && !setting.isDate && !setting.isDateTime" class="form-control" [(ngModel)]="input[setting.fieldName]" [disabled]="!setting.editable" />
                            <app-my-datepicker *ngIf="input._edit && !setting.isActionField && !setting.isSelectDownloadField && !setting.isSelectListField && (setting.isDate || setting.isDateTime)" [(dateModel)]="input[setting.fieldName]" [disabled]="!setting.editable"></app-my-datepicker>
                            <img *ngIf="setting.isImageField && input[setting.fieldName] && (setting.enableFieldName ? input[setting.enableFieldName] : true)" [src]="input[setting.fieldName]" />
                            <em *ngIf="setting.isIconField && input[setting.fieldName] && (setting.enableFieldName ? input[setting.enableFieldName] : true)" class="fa" [ngClass]="setting.actionClass"></em>
                        </td>
                    </tr>
                    <tr *ngFor="let setting of settings | arrayFilter:'isSelectDownloadField':true" (click)="setting.actionField(selected)">
                        <td attr.colspan="{{ settings.length }}" class="pointer">
                            <em *ngIf="!isDownloadingFile" class="fa fa-download"></em>
                            <em *ngIf="isDownloadingFile" class="fa fa-spinner rotating"></em>
                            &nbsp;&nbsp;Scarica selezionati ({{ _selected.length }} element{{_selected.length == 1? 'o':'i'}} di cui {{ _hideSelected }} non visibili con i filtri attuali)
                        </td>
                    </tr>
                    <tr *ngIf="allowPagination">
                        <td attr.colspan="{{ settings.length }}">

                            <div class="col-sm-2">
                                <label class="col-sm-5">El. per pagina</label>
                                <div class="col-sm-7">
                                    <select style="margin-bottom: 10px;" class="form-control" [(ngModel)]="elementsForPage" (change)="doSort()">
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="99999999999">Tutti</option>
                                    </select>
                                </div>
                            </div>
                            <div class="text-xs-right col-sm-10">
                                <ul class="pagination justify-content-center" style="margin-top:0px; margin-bottom:0px;">
                                    <li class="page-item pointer"><a class="page-link" (click)="changePage(true, false, 0, 0)">&laquo;</a></li>
                                    <li class="page-item pointer"><a class="page-link" (click)="changePage(false, false, -1, 0)">&lt;</a></li>
                                    <li class="page-item pointer" [class.active]="page==selectedPage" *ngFor="let page of pages"><a class="page-link" (click)="changePage(false, false, 0, page)">{{ page }}</a></li>
                                    <li class="page-item pointer"><a class="page-link" (click)="changePage(false, false, 1, 0)">&gt;</a></li>
                                    <li class="page-item pointer"><a class="page-link" (click)="changePage(false, true, 0, 0)">&raquo;</a></li>
                                </ul>
                            </div>


                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="card mobile">
    <div class="card-header card-info card-inverse">
        <span class="card-title"><em *ngIf="isDownloadingData" class="fa fa-spinner rotating"></em>&nbsp;&nbsp;{{ title }}</span>
    </div>
    <div class="card-block">
        <div class="row" *ngFor="let input of inputs">
            <ng-container *ngFor="let setting of settings; let i = index">
                <ng-container *ngIf="!input._edit && input[setting.fieldName] && !setting.isActionField && !setting.isSelectDownloadField && !setting.isSelectListField">
                    <div class="col-12 col-md-6">
                        <div class="form-group row">
                            <label class="col-4 col-md-3 form-control-label">{{ setting.fieldTitle }}</label>
                            <div class="col-8 col-md-9">
                                <div *ngIf="!setting.isImageField && !setting.isIconField">
                                    <span>
                                        {{ (setting.isDate ? (input[setting.fieldName] | date:'dd/MM/yyyy') : (setting.isDateTime ? (input[setting.fieldName] | date:'dd/MM/yyyy HH:mm:ss') : input[setting.fieldName]))  }}

                                        <span *ngIf="input[setting.suffix]">
                                            {{ input[setting.suffix] }}
                                        </span>
                                        <span *ngIf="!input[setting.suffix]">
                                            {{ (setting.suffix ? setting.suffix : '') }}
                                        </span>
                                    </span>
                                </div>
                                <img *ngIf="setting.isImageField && input[setting.fieldName] && (setting.enableFieldName ? input[setting.enableFieldName] : true)" [src]="input[setting.fieldName]" />
                                <em *ngIf="setting.isIconField && input[setting.fieldName] && (setting.enableFieldName ? input[setting.enableFieldName] : true)" class="fa" [ngClass]="setting.actionClass"></em>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <div class="col-12 text-right">
                <ng-container *ngFor="let setting of settings; let i = index">
                    <a *ngIf="!input._edit && setting.isActionField && !(setting.isToShowLoading && input._isDownloading) && (setting.enableFieldName ? input[setting.enableFieldName] : true)" class="pointer" (click)="setting.actionField(input)">
                        <em *ngIf="!hideActionFields" class="fa {{ setting.actionClass }} fa-2x"></em>
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
</div>
